import AnimatedSection from "./AnimatedSection";
import { Zap, Receipt } from "lucide-react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const About = () => {
  const image = "/lovable-uploads/60f7a1f0-0d44-4fc7-8c8e-2ec98c50c7d6.png";

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className="bg-white py-24" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-start">

          {/* Texto principal */}
          <AnimatedSection>
            <span className="mb-4 inline-block rounded-full bg-sergen-100 px-4 py-1.5 text-sm font-medium text-sergen-800">
              Por qué elegirnos
            </span>

            {/* TÍTULO DESKTOP */}
            <h2 className="hidden md:block mb-6 text-4xl font-bold text-black leading-tight">
              Reducimos hasta 49% tu factura eléctrica
            </h2>

            {/* TÍTULO MÓVIL */}
            <h2 className="block md:hidden mb-4 text-3xl font-bold text-black leading-snug">
              Reducimos hasta 49% tu factura eléctrica
            </h2>

            {/* PÁRRAFOS DESKTOP */}
            <p className="hidden md:block mb-4 text-lg text-gray-700 text-justify">
              En <strong>SERGEN</strong> ayudamos a las industrias a gastar menos energía y pagar lo justo.
              Nuestro enfoque combina análisis técnico, control predictivo de demanda y revisión de tarifas
              para eliminar sobrecostos en tu facturación eléctrica.
            </p>

            <p className="hidden md:block mb-8 text-lg text-gray-700 text-justify">
              Detectamos ineficiencias en consumo, potencia contratada y penalidades, logrando una reducción
              real y sostenible sin afectar tu producción. Además, hemos recuperado más de medio millón de soles
              en reintegros por facturación eléctrica mal calculada.
            </p>

            {/* PÁRRAFOS MÓVIL (VERSIÓN CORTA) */}
            <p className="block md:hidden mb-3 text-base text-gray-700 leading-snug">
              Ayudamos a las industrias a reducir su factura eléctrica con análisis técnico y control predictivo.
            </p>

            <p className="block md:hidden mb-6 text-base text-gray-700 leading-snug">
              Eliminamos sobrecostos y detectamos ineficiencias sin afectar tu producción.
            </p>

            {/* Métricas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

              {/* Ahorro */}
              <div className="p-6 rounded-xl bg-sergen-50 hover:bg-sergen-100 transition-all duration-300 shadow-md text-center">
                <Zap className="h-10 md:h-10 w-10 text-sergen-600 mb-2 mx-auto" />
                
                {/* Números más pequeños en móvil */}
                <h4 className="text-4xl md:text-5xl font-extrabold text-sergen-600 whitespace-nowrap">
                  {inView ? <CountUp end={36} duration={3} /> : "0"}%
                </h4>

                <p className="mt-1 text-base md:text-lg font-semibold text-gray-800">
                  Ahorro Real Promedio
                </p>

                <p className="text-sm text-gray-600 mt-1 max-w-[260px] mx-auto hidden md:block">
                  Reducción en energía, potencia y costos adicionales en cada factura.
                </p>

                {/* versión móvil más corta */}
                <p className="text-sm text-gray-600 mt-1 block md:hidden">
                  Reducción de costos energéticos.
                </p>
              </div>

              {/* Reintegros */}
              <div className="p-6 rounded-xl bg-sergen-50 hover:bg-sergen-100 transition-all duration-300 shadow-md text-center">
                <Receipt className="h-10 md:h-10 w-10 text-sergen-600 mb-2 mx-auto" />

                <h4 className="text-4xl md:text-5xl font-extrabold text-sergen-600 whitespace-nowrap flex items-baseline justify-center">
                  S/ {inView ? <CountUp end={500} duration={3} /> : "0"}
                  <span className="ml-1 text-3xl md:text-4xl font-extrabold">K</span>
                </h4>

                <p className="mt-1 text-base md:text-lg font-semibold text-gray-800">
                  Reintegros Obtenidos
                </p>

                <p className="text-sm text-gray-600 mt-1 max-w-[260px] mx-auto hidden md:block">
                  Facturas corregidas y devoluciones logradas.
                </p>

                <p className="text-sm text-gray-600 mt-1 block md:hidden">
                  Facturas corregidas con devoluciones.
                </p>
              </div>
            </div>
          </AnimatedSection>

          {/* Imagen principal */}
          <AnimatedSection>
            <div className="relative w-full rounded-2xl overflow-hidden shadow-xl shadow-gray-300/40">
              <img
                src={image}
                alt="Ingeniero SERGEN revisando tablero eléctrico industrial"
                className="w-full h-full max-h-[420px] md:max-h-[720px] object-cover object-top"
              />
            </div>
          </AnimatedSection>

        </div>
      </div>
    </section>
  );
};

export default About;
